import { useState } from "react";
import { FaDownload, FaCheck } from "react-icons/fa";
import { Loader2 } from "lucide-react";

export default function DownloadCVButton() {

    const [status, setStatus] = useState("idle");

    const handleDownload = async () => {

        if (status === "downloading") return;

        try {

            setStatus("downloading");

            // simulate loading
            await new Promise((resolve) =>
                setTimeout(resolve, 1500)
            );

            const link = document.createElement("a");

            link.href = "/CV/Besmillah-Hakimi.pdf";
            link.download = "Besmillah-Hakimi-CV";

            document.body.appendChild(link);

            link.click();

            document.body.removeChild(link);

            setStatus("success");

            setTimeout(() => {
                setStatus("idle");
            }, 2500);

        } catch (error) {

            setStatus("idle");
        }
    };

    return (
        <button
            onClick={handleDownload}
            disabled={status === "downloading"}
            className={`
                relative overflow-hidden flex items-center gap-2
                rounded-md border md:border-2 border-primary
                py-[6px] px-4 font-medium transition-all duration-300
                disabled:opacity-70 disabled:cursor-not-allowed

                ${status === "success"
                    ? "bg-green-500 text-white border-green-500"
                    : "bg-transparent text-gray-800 dark:text-white hover:text-white"
                }

                before:absolute before:left-0 before:top-0
                before:-z-10 before:h-full before:w-full
                before:origin-top-left before:scale-x-0
                before:bg-primary before:transition-transform
                before:duration-300 before:content-['']
                hover:before:scale-x-100
            `}
        >

            {/* ICON */}
            {status === "idle" && (
                <FaDownload className="text-primary dark:text-white" />
            )}

            {status === "downloading" && (
                <Loader2 className="animate-spin w-4 h-4" />
            )}

            {status === "success" && (
                <FaCheck className="w-4 h-4" />
            )}

            {/* TEXT */}
            <span>
                {status === "idle" && "Download CV"}

                {status === "downloading" && "Preparing Download..."}

                {status === "success" && "Downloaded"}
            </span>

        </button>
    );
}